<template>
  <tr>
    <th>{{ division.name }}</th>
    <td>
      ${{ formatPrice(division.price) }}
    </td>
    <td>
      <div
        v-if="division.events_docs.length > 0"
      >
        <span
          v-for="(event, index) in division.events_docs"
          :key="event._id"
        >
          <a
            href="#"
            @click.prevent="editEvent(event)"
          >{{ event.name }}</a>
          <span v-if="index < division.events_docs.length - 1"><br></span>
        </span>
      </div>
      <div
        v-else
      >
        <a
          href="#"
          class="button is-small is-link is-outlined"
          @click.prevent="addEvent"
        >
          <span><PlusCircle />&nbsp;Add</span>
        </a>
      </div>
    </td>
    <td>
      <div class="dropdown is-hoverable is-right">
        <div class="dropdown-trigger">
          <button class="button is-light" aria-haspopup="true" aria-controls="dropdown-menu">
            <span>Actions</span>
            <span>&nbsp;<ChevronDown aria-hidden="true" /></span>
          </button>
        </div>
        <div class="dropdown-menu" id="dropdown-menu" role="menu">
          <div class="dropdown-content">
            <a
              href="#"
              class="dropdown-item"
              @click.prevent="editDivision(division)"
            >
              <span><Pencil />&nbsp;Edit</span>
            </a>
            <a
              href="#"
              class="dropdown-item"
              @click.prevent="addEvent"
            >
              <span><PlusCircle />&nbsp;Manage Events</span>
            </a>
            <hr class="dropdown-divider">
            <a
              href="#"
              class="dropdown-item has-text-danger"
              @click.prevent="deleteDivision"
            >
              <span><Delete />&nbsp;Delete</span>
            </a>
          </div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
import Close from 'vue-material-design-icons/Close.vue'
import ChevronDown from 'vue-material-design-icons/ChevronDown.vue'
import Pencil from 'vue-material-design-icons/Pencil.vue'
import PlusCircle from 'vue-material-design-icons/PlusCircle.vue'
import Delete from 'vue-material-design-icons/Delete.vue'
import datesMixin from '@/mixins/dates'
import priceMixin from '@/mixins/price'

export default {
  name: 'DivisionRow',
  mixins: [datesMixin, priceMixin],
  components: {
    Close,
    ChevronDown,
    Pencil,
    PlusCircle,
    Delete
  },
  props: {
    division: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      checkboxState: this.isActive
    }
  },
  methods: {
    editDivision (division) {
      this.$emit('editDivision', {
        _id: division._id,
        name: division.name,
        price: division.price
      })
    },
    editEvent (event) {
      this.$emit('editEvent', {
        _id: event._id,
        name: event.name,
        description: event.description,
        startDate: event.eventStartDate,
        endDate: event.eventEndDate,
        registrationPeriod: event.registrationPeriod,
        registrationStartDate: event.registrationStartDate,
        registrationEndDate: event.registrationEndDate
      })
    },
    deleteDivision () {
      this.$toasted.error('Divisions can\'t be removed for now.')
    },
    addEvent () {
      this.$emit('addEvent', this.division._id)
    }
  }
}
</script>

<style lang="scss" scoped>
  .actions{
    .button:nth-of-type(1){
      margin-right: 5px;
    }
  }
</style>
